module.exports = __webpack_public_path__ + "img/sushi4.84dbd091.jpg";